import { container } from 'inversify-props';
import {
	IReportsService, ReportsService,
} from '../services/reports';


export default () => {
	container.bind<IReportsService>('IReportsService').to(ReportsService);
};
